import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { CreateDeviceReferenceMovement } from 'app/dtos/referenceDeviceMovement/createReferenceDeviceMovement';
import { UploadExcelMovement } from 'app/dtos/referenceDeviceMovement/uploadExcelMovement';

@Injectable({
  providedIn: 'root'
})
export class ReferenceDeviceMovementService {

  constructor(private httpClientService: HttpClientService) { }

  async getByIdDeviceReferenceMovement(page, size, id, is_MeasurementValue) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.ReferenceDeviceMovement,
      queryString: `page=${page}&size=${size}&id=${id}&Is_MeasurementValue=${is_MeasurementValue}`,
      action: "GetDeviceByIdReferenceMovements"
    });
    return await firstValueFrom(observable);
  }

  async createUploadDeviceReferenceMovement(uploadExcelMovements: UploadExcelMovement[]) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.ReferenceDeviceMovement,
      action: "UploadExcelDeviceMovements"
    }, uploadExcelMovements);
    return await firstValueFrom(observable);
  }

  async createDeviceReferenceMovement(createDeviceReferenceMovement: CreateDeviceReferenceMovement) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.ReferenceDeviceMovement
    }, createDeviceReferenceMovement);
    return await firstValueFrom(observable);
  }

  async updateDeviceReferenceMovement(createDeviceReferenceMovement: CreateDeviceReferenceMovement) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.ReferenceDeviceMovement
    }, createDeviceReferenceMovement);
    return await firstValueFrom(observable);
  }

  async getByIdReferenceDeviceMovement(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.ReferenceDeviceMovement
    }, id);
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
